import styled from '@emotion/styled';
import React from 'react';

interface BoardInfoProps {
  name: string | undefined;
  version: number | string | undefined;
  objectCount: number;
  zoom: number;
}

const BoardInfo: React.FC<BoardInfoProps> = ({ name, version, objectCount, zoom }) => (
  <Root>
    <Row>
      <Label>Board</Label>
      <Value>{name ?? '—'}</Value>
    </Row>
    <Row>
      <Label>Version</Label>
      <Value>{version ?? '—'}</Value>
    </Row>
    <Row>
      <Label>Objects</Label>
      <Value>{objectCount}</Value>
    </Row>
    <Row>
      <Label>Zoom</Label>
      <Value>{zoom.toFixed(2)}×</Value>
    </Row>
  </Root>
);

export default BoardInfo;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
`;

const Label = styled.span`
  color: #6b7280;
`;

const Value = styled.span`
  color: #111827;
  font-weight: 500;
`;
